import AuFlag from 'flag-icon-css/flags/1x1/au.svg';
import CnFlag from 'flag-icon-css/flags/1x1/cn.svg';
import GbFlag from 'flag-icon-css/flags/1x1/gb.svg';
import JpFlag from 'flag-icon-css/flags/1x1/jp.svg';
import KrFlag from 'flag-icon-css/flags/1x1/kr.svg';
import NzFlag from 'flag-icon-css/flags/1x1/nz.svg';
import * as React from 'react';

import { SvgIcon, SvgIconProps, makeStyles } from '@material-ui/core';

import { Locale } from '../../types/i18n.types';

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: '50%',
  },
}));
const DefaultFlag = AuFlag;

export const Icon: React.FC<{ locale: Locale } & SvgIconProps> = ({
  locale,
  ...props
}) => {
  const classes = useStyles();
  function getFlag(): React.FC {
    switch (String(locale).toLowerCase()) {
      case 'en-au':
        return AuFlag;
      case 'en-nz':
        return NzFlag;
      case 'en-gb':
        return GbFlag;
      case 'ko-kr':
        return KrFlag;
      case 'ja-jp':
        return JpFlag;
      case 'zh-cn':
        return CnFlag;
      default:
        return DefaultFlag;
    }
  }
  const Flag: React.FC = getFlag();
  return (
    <SvgIcon className={classes.root} {...props}>
      <Flag />
    </SvgIcon>
  );
};

export default Icon;
